var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-sheet',{staticClass:"d-flex flex-column",attrs:{"height":"100%","flat":""}},[_c('KeepAlive',{attrs:{"include":"MainView"}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }